import styled from '@emotion/styled';

export const Status = styled.div`
  font-size: 16px;
  font-weight: 600;
`;
